const ticket = {
  event_required: 'The ticket must belong to an event',
  product_required: 'A product is required',
  contact_required: 'A contact is required',
  status_required: 'A status is required',
  status_invalid: 'Invalid ticket status',
  identifier_required: 'A ticket number is required for this product',
  sold_price_negative: 'The sold price cannot be negative',
  email_invalid: 'Must be a valid email address',
  save_error: 'Error saving ticket',
};

export default ticket;
